<template>
    <div class="reservation-actions">
        <button class="btn btn--danger" @click="cancelReservation">Отменить резерв</button>
        <button class="btn" @click="extendReservation">Продлить (+15 мин)</button>
    </div>
</template>

<script setup lang="ts">
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ detail: { id: number | string } }>();

const reservationId = (): string => String(props.detail.id);

async function cancelReservation(): Promise<void> {
    if (!confirm('Отменить резервирование?')) return;
    await request({
        method: 'post',
        url: `/admin-api/reservations/${reservationId()}/cancel/`,
        data: {},
    });
    window.location.reload();
}

async function extendReservation(): Promise<void> {
    if (!confirm('Продлить резерв на 15 минут?')) return;
    await request({
        method: 'post',
        url: `/admin-api/reservations/${reservationId()}/extend/`,
        data: { minutes: 15 },
    });
    window.location.reload();
}
</script>

<style scoped>
.reservation-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .reservation-actions .btn { min-height: 2.5rem; }
}
</style>
